import React from "react";
import { useSelector } from "../../../app/helpers";
import { RootState } from "../../../app/rootReducer";
import { ScheduleEventContentIcon } from "../../../components/Schedule/schedule-event-content-icon.component";
import type { Dashboard2DayBookingSummary } from "../types/dashboard2-work-status.types";
import { bookingSummaryToIconSchedule } from "../utils/dashboard2-schedule.utils";

const PILL_ICON_SIZE_PX = 16;

type Dashboard2WeekDayBookingPillIconProps = {
  booking: Dashboard2DayBookingSummary;
};

export const Dashboard2WeekDayBookingPillIcon: React.FC<Dashboard2WeekDayBookingPillIconProps> = ({
  booking
}) => {
  const userId = useSelector((state: RootState) => state.login.userInformation.sub);

  return (
    <ScheduleEventContentIcon
      schedule={bookingSummaryToIconSchedule(booking)}
      userId={userId}
      iconSize={PILL_ICON_SIZE_PX}
      showConferenceVisitorContactLink={false}
    />
  );
};
